import { useState } from 'react';
import { Settings, User, ChevronRight } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function SettingButton() {
    const [isOpen, setIsOpen] = useState(false);
    const userData = JSON.parse(localStorage.getItem("user_data") || '{}');

    return (
        <div className="relative inline-block">
            <button
                onClick={() => setIsOpen(!isOpen)}
                className={`
                    w-10 h-10 rounded-lg flex items-center justify-center
                    transition-all duration-300 group
                    ${isOpen
                        ? 'bg-gray-200 ring-4 ring-gray-300/50'
                        : 'hover:bg-gray-100'
                    }
                `}
            >
                <Settings className={`
                    w-5 h-5 transition-all duration-300
                    ${isOpen ? 'text-gray-800 rotate-90' : 'text-gray-600 group-hover:text-gray-800'}
                `} />
            </button>

            {isOpen && (
                <>
                    <div
                        className="fixed inset-0 z-40"
                        onClick={() => setIsOpen(false)}
                    />

                    <div className="absolute right-0 top-full mt-3 w-80 bg-white rounded-2xl shadow-2xl z-50 overflow-hidden animate-in fade-in slide-in-from-top-2 duration-300">
                        <div className="bg-gradient-to-br from-blue-600 to-blue-700 p-5 text-white">
                            <div className="flex items-center gap-4">
                                <div className="w-14 h-14 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center text-2xl font-bold">
                                    {userData.name ? userData.name.charAt(0) : 'U'}
                                </div>
                                <div>
                                    <h4 className="font-bold text-lg">
                                        {userData.name
                                            ? userData.name.length > 20
                                                ? `${userData.name.slice(0, 20)}…`
                                                : userData.name
                                            : 'Unknown User'}
                                    </h4>
                                    <p className="text-blue-100 text-sm">{userData.email || 'No Email'}</p>
                                </div>
                            </div>
                        </div>

                        <div className="p-3 space-y-1">
                            {[
                                { icon: User, path: "user/setting", label: 'Settings', color: 'from-purple-500 to-purple-600' },
                                // { icon: CreditCard, path: "user/account", label: 'Account and Billing', color: 'from-green-500 to-emerald-600' },
                            ].map((item, index) => {
                                const Icon = item.icon;
                                return (
                                    <Link
                                        key={item.label}
                                        to={item.path}
                                        className="w-full group flex items-center gap-4 p-4 rounded-xl hover:bg-gray-50 transition-all duration-200 hover:scale-[1.02]"
                                        style={{ animationDelay: `${index * 50}ms` }}
                                    >
                                        <div className={`w-11 h-11 rounded-xl bg-gradient-to-br ${item.color} flex items-center justify-center shadow-md group-hover:shadow-lg transition-all duration-200`}>
                                            <Icon className="w-5 h-5 text-white" />
                                        </div>
                                        <span className="flex-1 text-left font-medium text-gray-800 group-hover:text-gray-900">
                                            {item.label}
                                        </span>
                                        <ChevronRight className="w-5 h-5 text-gray-400 group-hover:text-gray-600 transition-all group-hover:translate-x-1" />
                                    </Link>
                                );
                            })}
                        </div>
                    </div>
                </>
            )}
        </div>
    );
}
